"use strict";

/*
 * Der Bilderwechsler im Kopfbereich - ohne Bootstrap-JavaScript.
 *
 * Am 2026-09-08 eingefuehrt, zusammen mit modal.js, dropdown.js, collapse.js
 * und reiter.js. Die vier kommen von phantomstaffel; dieses hier gibt es dort
 * nicht, weil phantomstaffel keinen Bilderwechsler hat.
 *
 * Bedient genau dieselben Attribute wie vorher, es musste also kein Template
 * angefasst werden (Partials/Page/Header.html):
 *
 *   .carousel[data-bs-ride="carousel"][data-bs-interval="3000"]
 *   .carousel-item, .active
 *   .carousel-indicators button[data-bs-slide-to][data-bs-target]
 *   button[data-bs-slide="prev"|"next"][data-bs-target]
 *
 * Und es setzt dieselben Klassen, denn das CSS von Bootstrap bleibt.
 *
 * WARUM DAS SO KURZ SEIN DARF: der Wechsler hier traegt `carousel-fade`. Bei
 * Bootstrap heisst das, dass die Bilder uebereinander liegen und nur die
 * Deckkraft wandert - `transform: none`. Es genuegt also, `.active` zu
 * verschieben, das Ueberblenden macht das Stylesheet. Fuer einen schiebenden
 * Wechsler (ohne `carousel-fade`) waeren zusaetzlich die Klassen
 * `carousel-item-next`, `-prev`, `-start`, `-end` in der richtigen Reihenfolge
 * noetig; das braucht hier niemand.
 *
 * NICHT nachgebaut, weil Bootstrap es auch nicht anders macht: die Pfeiltasten
 * (Bootstrap: `keyboard: true`, greift nur bei Fokus im Wechsler) und das
 * Wischen. Auf `prefers-reduced-motion` haelt der Wechsler ebenfalls nicht an -
 * Bootstrap tut das auch nicht, und der Umzug soll nichts aendern.
 */

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".carousel").forEach(einrichten);
});

function einrichten(karussell) {
    const bilder = karussell.querySelectorAll(".carousel-item");
    if (bilder.length === 0) {
        return;
    }

    /*
     * Die Bedienelemente zeigen per data-bs-target auf die Kennung des
     * Wechslers und liegen hier innerhalb davon. Gesucht wird trotzdem im
     * ganzen Dokument, denn Bootstrap erlaubt beides.
     */
    const zeiger = karussell.id ? '[data-bs-target="#' + karussell.id + '"]' : null;
    const punkte = zeiger
        ? document.querySelectorAll(zeiger + "[data-bs-slide-to]")
        : karussell.querySelectorAll("[data-bs-slide-to]");
    const knoepfe = zeiger
        ? document.querySelectorAll(zeiger + "[data-bs-slide]")
        : karussell.querySelectorAll("[data-bs-slide]");

    let jetzt = 0;
    bilder.forEach((bild, i) => {
        if (bild.classList.contains("active")) {
            jetzt = i;
        }
    });

    const zeigen = (wunsch) => {
        let i = wunsch % bilder.length;
        if (i < 0) {
            i += bilder.length;
        }
        if (i === jetzt) {
            return;
        }

        bilder.forEach((bild, k) => bild.classList.toggle("active", k === i));
        punkte.forEach((punkt, k) => {
            punkt.classList.toggle("active", k === i);
            if (k === i) {
                punkt.setAttribute("aria-current", "true");
            } else {
                punkt.removeAttribute("aria-current");
            }
        });

        jetzt = i;
    };

    punkte.forEach((punkt, k) => {
        punkt.addEventListener("click", () => {
            zeigen(Number(punkt.dataset.bsSlideTo !== undefined ? punkt.dataset.bsSlideTo : k));
            neustarten();
        });
    });

    knoepfe.forEach((knopf) => {
        knopf.addEventListener("click", () => {
            zeigen(jetzt + (knopf.dataset.bsSlide === "prev" ? -1 : 1));
            neustarten();
        });
    });

    /*
     * Weiterschalten nur, wenn das Markup es verlangt. `data-bs-ride` steht
     * auf der Startseite, sonst nirgends.
     */
    let uhr = null;
    const takt = Number(karussell.dataset.bsInterval) || 5000;
    const laeuft = () => karussell.dataset.bsRide === "carousel" && bilder.length > 1;

    const starten = () => {
        if (!laeuft() || uhr !== null) {
            return;
        }
        uhr = window.setInterval(() => zeigen(jetzt + 1), takt);
    };
    const anhalten = () => {
        if (uhr !== null) {
            window.clearInterval(uhr);
            uhr = null;
        }
    };
    const neustarten = () => {
        anhalten();
        starten();
    };

    /* Bootstrap haelt beim Ueberfahren an (`pause: "hover"`). Genauso hier. */
    karussell.addEventListener("mouseenter", anhalten);
    karussell.addEventListener("mouseleave", starten);

    /*
     * Im Hintergrundtab nicht weiterschalten. Das tut Bootstrap ebenfalls,
     * ueber seinen Sichtbarkeits-Horcher.
     */
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
            anhalten();
        } else {
            starten();
        }
    });

    starten();
}
